export default __webpack_public_path__ + "static/media/sb-provider.ed4e2680.webp";